export default "__VITE_ASSET__4675a2c3__"